export default __webpack_public_path__ + "static/media/8.d99d2089.jpg";